import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter as Link } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Button from '@material-ui/core/Button';
import AuthService from '../../Services/AuthService';



const styles = {
  root: {
    flexGrow: 1,
  },
  flex: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
};


class MenuAppBar extends Component {
  constructor(props){
    super(props)
    this.Auth = new AuthService();
    this.state = {
      auth: false,
      lead: '',
      anchorEl: null,
      username: ''
    };
  }

  componentWillMount(){
    if(this.Auth.loggedIn()) {
      this.state.auth = true;
      this.state.username = localStorage.getItem('username');
      this.state.lead = localStorage.getItem('hasLead');
    }
    else {
      this.state.auth = false;
    }
  }

  goTo(route) {
    this.props.history.replace(`/${route}`)
  }

  handleChange = (event, checked) => {
    this.setState({ auth: checked });
  };

  logout() {
    this.Auth.logout();
    window.location.reload()
  }

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { classes } = this.props;
    const { auth, lead, anchorEl, username } = this.state;
    const open = Boolean(anchorEl);
    
    return (
      <div className={classes.root}>
        <AppBar position="static" style={{ background: '#2E3B55' }}>
          <Toolbar>
          <Typography variant="title" color="inherit" className={classes.flex}>
          <nav class="nav">
           <ul>
             <li class="current">
             <Button variant="inlined" href="/" color="inherit">
              Home
            </Button>
            </li>
            <li>
            <Button variant="inlined" href="/projects" color="inherit">
                  Projects
            </Button>
            </li>
            <li>
            <Button variant="inlined" href="/articles" color="inherit">
                  Articles
            </Button>
            </li>
            <li>
            <Button variant="inlined" href="/tutorials" color="inherit">
                  Tutorials
            </Button>
            </li>
           </ul>
          </nav>
          </Typography>

            {auth && lead==1 &&(
              <div>
                <Button variant="inlined" color="inherit">
                  {username}
                </Button>
                <IconButton
                  aria-owns={open ? 'menu-appbar' : null}
                  aria-haspopup="true"
                  onClick={this.handleMenu}
                  color="inherit"
                >
                  <AccountCircle />
                </IconButton>
              </div>
            )}
           
              <div>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={open}
                  onClose={this.handleClose}
                >
                  <MenuItem onClick={this.handleClose} component={Link} to="/createlead">Register Personal Info</MenuItem>
                  <MenuItem onClick={this.handleClose} component={Link} to="/account">My account</MenuItem>
                  <MenuItem onClick={this.handleClose} onClick={this.logout.bind(this)} >Logout</MenuItem>
                </Menu>
              </div>
        
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

MenuAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MenuAppBar);



// WEBPACK FOOTER //
// ./src/components/Header/NavBar.js